module.exports = __webpack_public_path__ + "img/1.55a36b90.png";